module.exports = __webpack_public_path__ + "img/6.562c1a3d.png";